import SchoolsAdapter from './base';

export default class Location extends SchoolsAdapter {
  modelNamePlural = 'locations';
}
